import clsx from "clsx";
import { isMobile } from "react-device-detect";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

import { globalStateSelector } from "../../../redux/globalState/globalStateSlice";
import { shouldShowAdsSelector } from "../../../redux/user/userSlice";
import styles from "./Footer.module.css";

const Footer = () => {
  const globalState = useSelector(globalStateSelector);
  let footer: JSX.Element;
  if (globalState.showFooter && (!globalState.isSearching || !isMobile)) {
    footer = (
      <section
        className={clsx(
          "z-10 bg-primary-dark",
          // shouldShowAds && !isMobile && "pb-48",
          // Figure out what to do with mobile and ads
        )}
      >
        {isMobile ? (
          <div className="h-12.5" />
        ) : (
          <>
            <div className={styles.footerBreak} />
            <div className={styles.footer}>
              <div className={styles.footerContent}>
                {/* <a
                  href={"https://fc24.easysbc.io/"}
                  target="_blank"
                  rel="noreferrer"
                  className={styles.footerElement}
                >
                  FC 24
                </a> */}
                <NavLink to={"/legal"} className={styles.footerElement}>
                  Legal & FAQ
                </NavLink>
                <a></a>
                {import.meta.env.VITE_APP_SHOW_COMPONENTS && (
                  <NavLink to={"/components"} className={styles.footerElement}>
                    <img
                      className="w-8"
                      src="https://ionicframework.com/docs/icons/logo-react-icon.png"
                      alt="react-icon"
                    />
                  </NavLink>
                )}
                <div className={styles.footerElement}>
                  <span>
                    Copyright © 2025{" "}
                    <span className={styles.footerElementHighlight}>
                      easySBC.io
                    </span>
                    . All EA FC 25 assets are property of EA Sports.
                  </span>
                </div>
              </div>
            </div>
          </>
        )}
      </section>
    );
  } else {
    footer = null;
  }
  return footer;
};

export default Footer;
